// 제작 현황 보드 '의뢰서확인' 진입 기록 (2026-08-05 대표 확정)
// — 기공소 수신자가 인쇄·다운로드·[CAD로 보내기] 중 하나를 실행한 주문만 보드에 표시.
// — 이미 processStage가 있으면 절대 쓰지 않음 (에이전트 자동 승격·수동 이동 역행 방지).
// — rules는 기존 공정 필드 분기(수신 기공소 hasOnly)로 통과, 신규 필드·rules 변경 없음.
import { doc, updateDoc, serverTimestamp, arrayUnion } from 'firebase/firestore';
import { db } from '../firebase/config';

// 같은 세션에서 중복 기록 방지 (화면 state가 갱신 안 된 채 두 번 눌러도 1회만)
const markedThisSession = new Set();

export function markOrderReceivedStage(order, user) {
    try {
        if (!order?.id) return;
        if (order.processStage) return;                          // 이미 공정 진행 중 — 역행 금지
        if (markedThisSession.has(order.id)) return;
        if (order.type === 'message') return;                    // 메시지형은 보드 대상 아님
        const targetId = user?.companyId || user?.uid;
        if (!targetId || targetId !== order.toUserId) return;    // 기공소 수신자만 (발신 치과는 rules상 쓰기 불가)
        markedThisSession.add(order.id);
        updateDoc(doc(db, 'workOrders', order.id), {
            processStage: 'received',
            stageUpdatedAt: serverTimestamp(),
            stageSource: 'manual',
            // 이력에 환자명 미포함 (ProductionBoard·에이전트와 동일)
            stageHistory: arrayUnion({ stage: 'received', at: new Date().toISOString(), source: 'manual' }),
        }).catch(e => {
            markedThisSession.delete(order.id);                  // 실패 시 재시도 가능하게 해제
            console.error('제작 현황(의뢰서확인) 기록 실패:', order.id, e);
        });
    } catch (e) {
        console.error('제작 현황(의뢰서확인) 기록 실패:', e);
    }
}
